import { redirect } from "@tanstack/react-router";

// legacyRedirectTo returns a `beforeLoad` callback for the legacy URL routes
// that were folded under /app/* and /admin/*. Each old top-level route
// (e.g. /clients, /jobs, /settings) still needs a real file route so
// TanStack registers the URL, but the body collapses to one line:
//
//     beforeLoad: legacyRedirectTo("/app/clients")
//
// `target` is typed as `string` rather than the auto-generated `LinkOptions`
// union because the redirects are static and we don't want to plumb the
// route-tree types into a tiny helper.
export function legacyRedirectTo(target: string): () => never {
  return () => {
    throw redirect({ to: target });
  };
}
